import { Grid } from "@material-ui/core";
import { useUser } from "@saleor/auth";
import {
  cartCustomerListUrl,
  CartCustomerQueryParams,
  cartListUrl,
  CartQueryParams
} from "@saleor/createOrder/urls";
import {
  getSortCartCustomerDetailQueryVariables,
  getSortCartDetailQueryVariables
} from "@saleor/createOrder/views/sort";
import {
  useCartCheckoutQuery,
  useCartTotalCheckoutQuery,
  useCustomerCartsQuery,
  useCustomerCartTotalsQuery
} from "@saleor/graphql";
import useNavigator from "@saleor/hooks/useNavigator";
import { usePaginationReset } from "@saleor/hooks/usePaginationReset";
import createSortHandler from "@saleor/utils/handlers/sortHandler";
import { mapEdgesToItems } from "@saleor/utils/maps";
import { getSortParams } from "@saleor/utils/sort";
import React from "react";

import CartInfo from "../CartInfo";
import CartInfoCustomer from "../CartInfoCustomer";
import CartTable from "../CartTable";
import CartTableCustomer from "../CartTableCustomer";

interface CartPageProps {
  params?: CartQueryParams;
  paramsCustomer?: CartCustomerQueryParams;
}

const CartPage: React.FC<CartPageProps> = ({ params, paramsCustomer }) => {
  const navigate = useNavigator();
  const { user, soldToId } = useUser();

  // For staff = true
  const { data: cartInfoData } = useCartTotalCheckoutQuery({
    displayLoader: true,
    skip: !user.isStaff
  });

  const { data: cartTableData } = useCartCheckoutQuery({
    displayLoader: true,
    variables: {
      first: 100,
      sortBy: getSortCartDetailQueryVariables(params)
    },
    skip: !user.isStaff
  });
  //
  // For staff = false
  const { data: cartInfoDataCustomer } = useCustomerCartTotalsQuery({
    variables: {
      soldToId
    },
    displayLoader: true,
    skip: user.isStaff
  });
  const { data: cartTableDataCustomer } = useCustomerCartsQuery({
    displayLoader: true,
    variables: {
      first: 100,
      sortBy: getSortCartCustomerDetailQueryVariables(paramsCustomer),
      soldToId
    },
    skip: user.isStaff
  });

  usePaginationReset(cartListUrl, params, 100);
  const handleSort = createSortHandler(navigate, cartListUrl, params);
  const handleSortCustomer = createSortHandler(
    navigate,
    cartCustomerListUrl,
    paramsCustomer
  );

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={3}>
          {user.isStaff ? (
            <CartInfo data={cartInfoData?.totalContractCheckouts} />
          ) : (
            <CartInfoCustomer data={cartInfoDataCustomer?.customerCartTotals} />
          )}
        </Grid>
        <Grid item xs={12} lg={9}>
          {user.isStaff ? (
            <CartTable
              data={mapEdgesToItems(cartTableData?.contractCheckouts)}
              onSort={handleSort}
              sort={getSortParams(params)}
            />
          ) : (
            <CartTableCustomer
              data={mapEdgesToItems(cartTableDataCustomer?.customerCarts)}
              onSort={handleSortCustomer}
              sort={getSortParams(paramsCustomer)}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default CartPage;
